import { infiniteQueryOptions } from "@tanstack/react-query";
import { GET_FOOTPRINT_HISTORY_FOR_WEB } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { FootprintListResponse } from "./types";

/**
 * 1 ページの取得件数（skip/take によるページネーション）。
 * 従来の固定取得（72 件）と初回表示件数を揃えるため 72 にしている（上限ではなくページサイズ）。
 * 72 件を超える分は無限スクロールで追加取得する。
 */
const FOOTPRINT_PAGE_SIZE = 72;

/**
 * 足跡（自分のプロフィールを訪れたユーザー）一覧。
 * get_footprint_history_for_web は last_login / video_call_waiting / voice_call_waiting も返すため
 * 補完取得は不要。skip/take の無限スクロールで全件たどれる（72 件上限は撤廃）。
 */
export const footprintListInfiniteQueryOptions = infiniteQueryOptions({
  queryKey: queryKeys.footprint.list(),
  queryFn: ({ pageParam }) =>
    apiClient<FootprintListResponse>(GET_FOOTPRINT_HISTORY_FOR_WEB, {
      skip: pageParam,
      take: FOOTPRINT_PAGE_SIZE,
    }),
  initialPageParam: 0,
  getNextPageParam: (lastPage, _allPages, lastPageParam) =>
    // 取得件数が take 未満なら最終ページ
    lastPage.length < FOOTPRINT_PAGE_SIZE
      ? undefined
      : lastPageParam + FOOTPRINT_PAGE_SIZE,
  // 足跡は「最新の訪問」を見せる一覧なので、開くたびに最新を取得する。
  // 既定の staleTime(5分) のままだと再訪問しても訪問時刻が更新されないため 0 にする。
  staleTime: 0,
});
